import React from 'react';
import { Button, Tag, Typography, theme } from 'antd';
import { BASE_CONTENIDO } from './contenido';
import { urlContenido } from './catalogo';

const { Text, Paragraph } = Typography;

const fechaLarga = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString('es-CL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

// Una publicación de novedades. `compacta` (feed del inicio) muestra solo el resumen; la completa (historial) trae
// todos los párrafos y la imagen. Las no leídas llevan un punto de color y el borde izquierdo resaltado.
//
// Props:
//   publicacion — normalizada (ver novedades.js).
//   leida — si la persona ya la vio.
//   onVerTutorial(idTutorial) — se llama al pulsar "Ver tutorial" (el padre marca como leída y abre el centro).
export default function NovedadItem({
  publicacion: p,
  leida,
  compacta = false,
  onVerTutorial,
  base = BASE_CONTENIDO,
}) {
  const { token } = theme.useToken();
  const resumen = p.resumen ?? p.cuerpo[0] ?? '';

  return (
    <article
      data-testid="novedad"
      data-leida={leida ? 'true' : 'false'}
      style={{
        padding: compacta ? '10px 12px' : '14px 16px',
        borderRadius: token.borderRadius,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderLeft: `3px solid ${leida ? token.colorBorderSecondary : token.colorPrimary}`,
        background: leida ? token.colorBgContainer : token.colorPrimaryBg,
        opacity: leida ? 0.85 : 1,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        {!leida ? (
          <span
            role="img"
            aria-label="Sin leer"
            style={{ width: 8, height: 8, borderRadius: 4, background: token.colorPrimary }}
          />
        ) : null}
        {p.etiqueta ? <Tag color="blue">{p.etiqueta}</Tag> : null}
        <Text type="secondary" style={{ fontSize: 12 }}>
          {fechaLarga(p.fecha)}
        </Text>
      </div>
      {!compacta && p.imagen ? (
        <img
          src={urlContenido(base, p.imagen)}
          alt=""
          style={{ width: '100%', borderRadius: token.borderRadius, margin: '8px 0' }}
        />
      ) : null}
      <div style={{ fontWeight: 600, margin: '4px 0' }}>{p.titulo}</div>
      {compacta ? (
        <Text type="secondary" style={{ fontSize: 13 }}>
          {resumen}
        </Text>
      ) : (
        (p.cuerpo.length ? p.cuerpo : [resumen]).map((parrafo) => (
          <Paragraph key={parrafo} style={{ marginBottom: 6 }}>
            {parrafo}
          </Paragraph>
        ))
      )}
      {p.tutorial ? (
        <div style={{ marginTop: 6 }}>
          <Button size="small" onClick={() => onVerTutorial?.(p.tutorial, p.id)}>
            Ver tutorial
          </Button>
        </div>
      ) : null}
    </article>
  );
}
